import { DialogStore } from '@vectorworks/vcs-ui/dist/lib/Dialog';

export default DialogStore;
